import { ApiError } from '@sara/api-client';

/**
 * Extracts a human-readable message from a failed API call.
 *
 * NestJS error bodies carry the useful detail in `data.message` — a string,
 * or a string array for class-validator failures (e.g. output schema
 * validation). `ApiError.message` itself is just "API error <status>", so
 * prefer the body and fall back to the Error message.
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  if (error instanceof ApiError && error.data && typeof error.data === 'object') {
    const { message } = error.data as { message?: unknown };
    if (typeof message === 'string' && message.length > 0) {
      return message;
    }
    if (Array.isArray(message)) {
      const strings = message.filter((m): m is string => typeof m === 'string');
      if (strings.length > 0) {
        return strings.join('\n');
      }
    }
  }
  return error instanceof Error ? error.message : undefined;
}
